var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input__row"},[_c('el-tiptap',{staticClass:"editor",class:{
      'editor--focused': _vm.isFocused || _vm.isNonEmpty,
    },attrs:{"tooltip":false,"showMenubar":false,"charCounterCount":false,"extensions":_vm.extensions,"content":_vm.currentContent,"placeholder":_vm.placeholder},on:{"onFocus":_vm.onFocus,"onBlur":_vm.onBlur,"onUpdate":_vm.onEditorUpdate}}),_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }